<div class="growerAddOuter">
  <div class="grower-add-sec">
    <div class="row grower-add-dropDown">
      <div class=" col-md-12 material-select">
        <ng-select name="ddlGrowerOrderAccount"
                   [items]="accountList"
                   class="custom-select-grower grower-add-drop"
                   [(ngModel)]="accountId"
                   [virtualScroll]="true"
                   bindLabel="accountNameCityState"
                   bindValue="accountNumber"
                   placeholder="Account:"
                   [loading]="accountLoading"
                   [closeOnSelect]="true"
                   [searchFn]="accountSearchFn"
                   (change)="getGrowerListByAccount($event)">
          <ng-template ng-label-tmp let-item="item" let-index="index">
            <div class="dropdown-template">
              <div class="row">
                <div class="col-md-8">
                  <h4 class="name greenColor" [ngOptionHighlight]="search">
                    {{item.accountName}}
                  </h4>
                  <p class="address" [ngOptionHighlight]="search">
                    {{item.address1}},  {{item.city}} <span class="d-none d-md-inline-block">,{{item.state}} - {{item.zipCode}}</span>
                  </p>
                  <p class="phoneNo d-none d-md-block" [ngOptionHighlight]="search">
                    {{item.primaryPhoneNumber}}
                  </p>
                  <p class="grower-nos">
                    <span class="grower-gln d-none d-md-block" [ngOptionHighlight]="search">
                      Account #: {{item.accountNumber}}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="dropdown-template">
              <div class="row">
                <div class="col-md-8">
                  <h4 class="name greenColor" [ngOptionHighlight]="search">
                    {{item.accountName}}
                  </h4>
                  <p class="address" [ngOptionHighlight]="search">
                    {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                  </p>
                  <p class="phoneNo" [ngOptionHighlight]="search">
                    {{item.primaryPhoneNumber}}
                  </p>
                  <p class="grower-nos">
                    <span class="grower-gln" [ngOptionHighlight]="search">
                      Account #: {{item.accountNumber}}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
              No data found for "{{searchTerm}}"
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row grower-add-dropDown">
      <div class="col-md-12 material-select">
        <ng-select name="ddlGrowerDetails"
                   [items]="growerList"
                   class="custom-select-grower grower-add-drop"
                   [(ngModel)]="growerGMK"
                   [virtualScroll]="true"
                   bindLabel="growerNameCityState"
                   placeholder="Grower:"
                   [loading]="growerLoading"
                   bindValue="gmk"
                   [searchFn]="growerSearchFn"
                   [closeOnSelect]="true"
                   (search)="search($event)"
                   (change)="onGrowerSelection($event)"
                   data-testid="ddl-grower-to-search">
          <ng-template ng-label-tmp let-item="item" let-index="index">
            <div class="dropdown-template">
              <div class="row">
                <div class="col-md-8">
                  <h4 class="name greenColor" [ngOptionHighlight]="search">
                    {{item.businessName}}
                  </h4>
                  <p class="address" [ngOptionHighlight]="search">
                    {{item.address1}},  {{item.city}}<span class="d-none d-md-inline-block">, {{item.state}} - {{item.zip}}</span>
                  </p>
                  <p class="phoneNo d-none d-md-block" [ngOptionHighlight]="search">
                    {{item.primaryPhoneNumber}}
                  </p>
                  <p class="grower-nos">
                    <span class="grower-gln d-none d-md-block" [ngOptionHighlight]="search">
                      Grower GMK: {{item.gmk}}
                    </span>
                    <span class="grower-gln d-none d-md-block" [ngOptionHighlight]="search">
                      Grower GLN: {{item.growerGLN}}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="dropdown-template" [attr.data-testid]="'ddl-grower-search-option_'+index">
              <div class="row">
                <div class="col-md-8">
                  <h4 class="name greenColor" [ngOptionHighlight]="search">
                    {{item.businessName}}
                  </h4>
                  <p class="address" [ngOptionHighlight]="search">
                    {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zip}}
                  </p>
                  <p class="phoneNo" [ngOptionHighlight]="search">
                    {{item.primaryPhoneNumber}}
                  </p>
                  <p class="grower-nos">
                    <span class="grower-gln" [ngOptionHighlight]="search">
                      Grower GMK: {{item.gmk}}
                    </span>
                    <span class="grower-gln" [ngOptionHighlight]="search">
                      Grower GLN: {{item.growerGLN}}
                    </span>
                  </p>
                </div>
                <div class="col-md-3 orderId-detail text-right">
                  Order:
                  <p *ngIf="item.growerOrderList.length > 0">{{item.OrderNumber}}</p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
              No data found for "{{searchTerm}}"
            </div>
          </ng-template>
          <ng-template ng-footer-tmp let-search="searchTerm">
            <div class="custom-drop-footer">
              <div class="row">
                <div class="col-lg-8 d-none d-lg-block">
                  <button mat-raised-button class="btns" color="primary" (click)="openGrowerSliderModel()">Advanced Search</button>
                </div>
                <div class="col-lg-4 bold text-right">
                  Results : {{searchCount}}
                </div>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="row" *ngIf="isSubscriptionAccess">
      <div class="col-md-12">
        <mat-form-field class="wide100">
          <mat-label>Non-Subscriber Email:</mat-label>
          <input matInput type="text" name="accountEmail" maxlength="250"
                 placeholder="(Separate multiple email addresses by a semi-colon)"
                 [(ngModel)]="accountEmail"
                 [pattern]="emailPattern"
                 (blur)="validateEmail()"
                 [errorStateMatcher]="matcher">
          <mat-error *ngIf="isInvalidEmail">
            This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <app-addeditorderdetail (GetErrorMsgs)="getCommonErrors($event)" [GrowerOrderObj]="growerOrderObj" [GrowerOrderItemList]="updatedProductList" [AccountId]="accountId"></app-addeditorderdetail>
  </div>
  <div class="common-error-block grower-order" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-3 col-md-1 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span>
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-9 col-md-7 padding-l0 ">
        <ol class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors; let i=index">
            {{i+1}}. {{err.error}}
          </li>
        </ol>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
</div>
